function modal(clickElement, closeElement) {
  document.querySelector(clickElement).addEventListener('click', function () {
    const target = document.querySelector(this.getAttribute('data-target'));
    target.style.display = 'flex';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
  });

  document.querySelector(closeElement).addEventListener('click', function () {
    const videoModal = document.querySelector('.video-modal');
    videoModal.style.display = 'none';
    document.body.style.width = 'auto';
    document.body.style.overflowY = 'auto';
    document.body.style.position = 'initial';
  });
}

modal('.watch-the-video-btn', '.video-modal-close');

document.addEventListener('click', function (e) {
  const target = e.target;
  const modalContent = document.querySelector('.video-modal-content');

  if (
    !target.matches('.watch-the-video-btn, .watch-the-video-btn *, .video-modal-content, .video-modal-content *')
  ) {
    const videoModal = document.querySelector('.video-modal');
    videoModal.style.display = 'none';
    document.body.style.width = 'auto';
    document.body.style.overflowY = 'auto';
    document.body.style.position = 'initial';
  }
});
